import { Component, Input, OnInit } from '@angular/core';

import { Recommendation } from '../../types/session.type';
import { DomSanitizer } from '@angular/platform-browser';
import { AdminService } from '../../services/admin.service';
import { Http } from '@angular/http';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'pdf-recommendation',
  templateUrl: './pdf-recommendation.html'
})

export class PDFRecommendationComponent implements OnInit {

  @Input() image: string;
  @Input() pair: Recommendation;
  imageToShow: any;

  constructor(
    public sanitizer: DomSanitizer,
    public adminService: AdminService,
    private httpClient: HttpClient
  ) {

  }

  // fetching and transforming image files to base64 for web pdfs
  ngOnInit() {
    this.httpClient.get(`assets/imgs/glasses/${this.image}.jpg`, { responseType: 'blob' }).subscribe(
      (data) => {
        this.createImageFromBlob(data);
      }
    );
  }

  backgroundImage(base64: string): any {
    return this.sanitizer.bypassSecurityTrustStyle(base64 ? `background-image: url(${base64})` : 'background-image: none');
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
       this.imageToShow = reader.result;
       console.log(this.imageToShow);
    }, false);

    if (image) {
       reader.readAsDataURL(image);
    }
 }
}



// WEBPACK FOOTER //
// ./src/components/pdf-recommendation/pdf-recommendation.component.ts